import React from "react";
import { Stack } from "@mui/material";
import { Typography } from "antd";

const Result = ({ score, group, level, answered }) => (
  <Stack gap={2} sx={{ width: "100%", textAlign: "center", mt: 7 }}>
    <Typography.Title level={4}>Тест завершён</Typography.Title>
    <Typography>
      Ваш уровень:{" "}
      <span style={{ fontWeight: "bold", color: "crimson" }}>{level}</span>
    </Typography>
    <Typography>
      Ваш результат {score}/{answered}
    </Typography>
    <Typography>
      Рекомендация: пройдите курс "
      <span style={{ fontWeight: "bold", color: "crimson" }}>{group}</span>"
      школы "Tamarjoba"
    </Typography>
  </Stack>
);

export default Result;
